import {
  INIT_PAYMENT_GATEWAY,
  INIT_PAYMENT_GATEWAY_SUCCESS,
  INIT_PAYMENT_GATEWAY_FAIL,
  INIT_BRAINTREE_CLIENT_FAIL,
  INIT_BRAINTREE_CLIENT,
  INIT_BRAINTREE_CLIENT_SUCCESS,
  INIT_BRAINTREE_3DSECURE_SUCCESS,
  INIT_BRAINTREE_HOSTEDFIELDS_SUCCESS,
  INIT_ADD_FREE_PAYMENT_FAIL,
  INIT_ADD_FREE_PAYMENT_SUCCESS,
  USER_PAYMENT_STATUS
} from '../actions/index'

export default function paymentGateway(state = {
    client_token: '',
    environment: '',
    payment_hosted_fields: null,
    paypal_active: null,
    venmo_active: null,
    apple_pay_active: null,
    type: '',
    braintreeClient: null,
    braintree3DSecure: null,
    braintreeHostedFields: null,
    adFreePayment: null
}, action) {
    switch(action.type) {
        case INIT_PAYMENT_GATEWAY: {
            return {
                ...state,
                error: '',
                loading: true,
            }
        }

        case INIT_PAYMENT_GATEWAY_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false,
            }
        }

        case INIT_PAYMENT_GATEWAY_SUCCESS: {
            const { data } = action.payload

            return {
                ...state,
                client_token: data.client_token,
                environment: data.environment,
                payment_hosted_fields: data.payment_hosted_fields,
                paypal_active: data.paypal_active,
                venmo_active: data.venmo_active,
                apple_pay_active: data.apple_pay_active,
                mai: data.mai,
                type: data.type,
                error: '',
                loading: false,
                braintreeClient: null,
                braintree3DSecure: null,
                braintreeHostedFields: null
            }
        }

        case INIT_BRAINTREE_CLIENT_SUCCESS: {
            return {
                ...state,
                error: '',
                loading: false,
                braintreeClient: action.payload
            }
        }

        case INIT_BRAINTREE_3DSECURE_SUCCESS: {
            return {
                ...state,
                error: '',
                loading: false,
                braintree3DSecure: action.payload
            }
        }

        case INIT_BRAINTREE_HOSTEDFIELDS_SUCCESS: {
            return {
                ...state,
                error: '',
                loading: false,
                braintreeHostedFields: action.payload
            }
        }

        case INIT_ADD_FREE_PAYMENT_FAIL: {
            return {
                ...state,
                error: '',
                loading: false,
                adFreePayment: action.payload
            }
        }

        case INIT_ADD_FREE_PAYMENT_SUCCESS: {
            return {
                ...state,
                error: '',
                loading: false,
                adFreePayment: action.payload
            }
        }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/payment-gateway.js